<template>
    <section
        class="step transition-all duration-300 py-2 lg:min-h-[500px] flex flex-col"
    >
        <div class="relative flex flex-row gap-3 flex-1">
            <!-- Source card -->
            <article
                class="w-1/2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-6 py-4"
            >
                <div class="mb-3">
                    <label for="credit-card-dropdown">From</label>
                    <WalletCardDropdown
                        id="credit-card-dropdown"
                        :model-value="selectedCard"
                        label="From"
                        :exclude-card="selectedReceivingCard"
                        @update:model-value="$emit('set-card-to-copy', $event)"
                        :disabled="currentStep === 2 || currentStep === 3"
                    />
                    <Errors :errors="errors['selectedCard']" class="pt-2" />
                </div>
                <div
                    v-if="!selectedCard"
                    class="pt-6 pb-16 flex justify-center items-center flex-col"
                >
                    <Icon icon="credit-cards" />
                    <div
                        class="pt-2 flex-col justify-start items-center gap-1 flex text-slate-500 dark:text-slate-400 text-sm font-normal font-['Inter'] leading-tight"
                    >
                        Select a card to begin.
                    </div>
                </div>
                <slot name="source-details"></slot>
            </article>
            <!-- Arrow icon -->
            <div
                class="absolute left-1/2 top-12 -translate-x-1/2 h-10 p-2.5 bg-white dark:bg-slate-800 rounded-full shadow-[0px_0px_0px_2px_rgba(255,255,255,1.00)] dark:shadow-[0px_0px_0px_2px_rgba(30,41,59,1.00)] border border-slate-200 dark:border-slate-700 justify-center items-center inline-flex overflow-hidden"
            >
                <div class="w-5 h-5 justify-center items-center flex overflow-hidden">
                    <div class="w-5 h-5 relative flex-col justify-start items-start flex overflow-hidden">
                        <Icon icon="arrow-right-alt" />
                    </div>
                </div>
            </div>
            <!-- Receiving card -->
            <article
                class="w-1/2 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-700/50 px-6 py-4"
            >
                <div class="mb-3">
                    <label for="receiving-card-dropdown">To</label>
                    <WalletCardDropdown
                        id="receiving-card-dropdown"
                        :model-value="selectedReceivingCard"
                        label="To"
                        :exclude-card="selectedCard"
                        @update:model-value="$emit('set-receiving-card', $event)"
                        :disabled="currentStep === 2 || currentStep === 3"
                    />
                    <Errors :errors="errors['receivingCard']" class="pt-2" />
                </div>
                <div
                    v-if="currentStep === 1"
                    class="pt-6 pb-16 flex justify-center items-center flex-col h-full"
                >
                    <div class="w-6 h-6 justify-center items-center flex overflow-hidden">
                        <Icon icon="credit-cards" />
                    </div>
                    <div
                        class="pt-2 flex-col justify-start items-center gap-1 flex text-slate-500 dark:text-slate-400 text-sm font-normal font-['Inter'] leading-tight"
                    >
                        Select a card to begin.
                    </div>
                </div>
                <slot name="receiving-details"></slot>
            </article>
        </div>
    </section>
</template>

<script setup>
import Errors from '@/components/errors.vue';
import Icon from '@/components/ui/icon/icon.vue';
import WalletCardDropdown from '@/components/wallet/wallet-card-dropdown.vue';

defineProps({
    selectedCard: { type: Object, default: null },
    selectedReceivingCard: { type: Object, default: null },
    currentStep: { type: Number, required: true },
    errors: { type: Object, required: true },
});

defineEmits(['set-card-to-copy', 'set-receiving-card']);
</script>
